import { Button, Field } from '@root/components/Form/Index';
import { useForceUpLiveHelp } from '@root/components/LiveHelpContext';
import { PageComponent } from '@root/pages/Type';
import classNames from 'classnames';
import { ReactNode, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styles from './Macro.module.scss';
import MethodsContrainers, {
    MethodsContainersProps,
} from './MethodsContrainers';

export type MacroContentProps = MethodsContainersProps & {
    buttonText?: string;
    disableEditableAmount?: boolean;
    isValid: boolean;
    submitting: boolean;
    prefixFields?: string;
    isFullSize?: boolean;
    isBlackOption?: boolean;
    fieldRow?: ReactNode;
};

const Content: PageComponent<MacroContentProps> = (props) => {
    const {
        disableEditableAmount,
        buttonText,
        isValid,
        submitting,
        prefixFields = '',
        methods,
        currentMethod,
        isFullSize = false,
        isBlackOption = false,
        fieldRow,
        ...rProps
    } = props;
    const { t } = useTranslation('uiPaymentsTopup');

    useForceUpLiveHelp();

    const method = useMemo(
        () =>
            methods
                .find((m) => m.items.find((i) => i.value === currentMethod))
                ?.items.find((i) => i.value === currentMethod),
        [methods, currentMethod],
    );

    return (
        <>
            <div className="form-row padding-additional">
                <div className="form-group col-sm-12 col-lg-6">
                    <Field
                        name={`${prefixFields}amount`}
                        label={
                            !disableEditableAmount
                                ? t('macro.enterAmount', {
                                      defaultValue: 'Įveskite sumą',
                                  })
                                : t('macro.amount', {
                                      defaultValue: 'Suma',
                                  })
                        }
                        type="number"
                        currency
                        maxLength={10}
                        readOnly={!!disableEditableAmount}
                        appendGroup={
                            <span className="input-group-text">€</span>
                        }
                    />
                </div>
                {fieldRow}
            </div>

            <MethodsContrainers
                {...rProps}
                methods={methods}
                currentMethod={currentMethod}
            />

            <div className={styles.payment_clear_bottom} />

            <div
                className={classNames(styles.sticky_button_container, {
                    [styles.black]: isBlackOption,
                    [styles.fullSize]: isFullSize,
                })}
            >
                <div className={`container ${styles.container}`}>
                    <div className={styles.method}>
                        {method && method.img && (
                            <img
                                src={`/static/img/payments/${method.img}.png`}
                                alt={method.img}
                            />
                        )}
                        {method && !method.img && method.translate}
                    </div>
                    <Button
                        type="submit"
                        className={classNames(
                            'btn btn-primary d-block ml-auto col-sm-4',
                            styles.btn,
                        )}
                        isLoading={submitting}
                        disabled={submitting || !isValid}
                    >
                        {buttonText || (
                            <Trans i18nKey="macro.button" ns="uiPaymentsTopup">
                                Papildyti
                            </Trans>
                        )}
                    </Button>
                </div>
            </div>
        </>
    );
};

export default Content;
